<template>
    <b-button
        variant="gradient-danger"
        class="btn-icon"
        size="sm"
        @click="$emit('exclude')"
    >
        <feather-icon icon="MinusIcon" />
    </b-button>
</template>

<script>
import {BButton} from 'bootstrap-vue'
export default {
    components: {
        BButton
    }
}
</script>
